export function store () {
  let _v = 1
  const listeners = new Set()

  return {
    get value () {
      return _v
    },
    set value (v) {
      _v = v
      listeners.forEach(fn => fn(v))
    },
    subscribe (fn) {
      listeners.add(fn)
      return () => listeners.delete(fn)
    }
  }
}

export const flagLandPositionX = store()

export const flagLandSteps = store()
flagLandSteps.value = 0

export const winLandPosition = (stepsToWin) => {
  flagLandSteps.value = stepsToWin
}

export const gameMultipliers = store()
export const setGameMultipliers = (m) => {
  gameMultipliers.value = m
}

export const isApiFetching = store()
isApiFetching.value = false

export const isChickenReached = store()
isChickenReached.value = true

export const frogReachedWinLand = store()
frogReachedWinLand.value = false

export const isFrogDie = store()
isFrogDie.value = false

export const isGameStart = store()
isGameStart.value = false

export const clickedLeaf = store()
clickedLeaf.value = false
